export default () => {
  console.log('Custom Select Module Loaded');
};

export const customSelect = (context: HTMLElement | Document = document, callback) => {
  const instances = context.querySelectorAll<HTMLElement>('.custom-select');

  instances.forEach((customSelect) => {
    customSelect.addEventListener('click', () => {
      customSelect.classList.contains('active')
        ? customSelect.classList.remove('active')
        : customSelect.classList.add('active');
    });

    const options = customSelect.querySelectorAll('.custom-select__panel li') as NodeListOf<HTMLElement>;

    options.forEach((option) => {
      option.addEventListener('click', (e: any) => {
        customSelectUpdate(customSelect, e.target.dataset.title).then((data) => {
          callback(data);
        });
      });
    });
  });

  document.addEventListener('click', (e: any) => {
    instances.forEach((customSelect) => {
      if (!customSelect.contains(e.target) && !e.target.classList.contains('js-empty-size')) {
        customSelect.classList.remove('active');
      }
    });
  });
};

export const customSelectGetCurrentSelection = (customSelect: HTMLElement) => {
  const options = customSelect.querySelectorAll('.custom-select__panel li') as NodeListOf<HTMLElement>;
  let value = null;

  options.forEach((option) => {
    if (option.dataset.selected === 'true') {
      value = option.dataset.value;
    }
  });

  return value;
};

export async function customSelectUpdate(customSelect: HTMLElement, title: string) {
  const options = customSelect.querySelectorAll('.custom-select__panel li') as NodeListOf<HTMLElement>;
  const input = customSelect.querySelector('input') as HTMLInputElement;
  const displayTitle = customSelect.querySelector('.custom-select__value') as HTMLElement;
  const extraAttributes = customSelect.dataset;

  let data = {
    value: '',
    title: '',
    name: '',
    gid: '',
    hasChanged: false,
    parent: null,
    extraAttributes: {},
    extraOptionAttributes: {}
  };

  options.forEach((option) => {
    if (option.dataset.title === title) {
      const value = option.dataset.value;
      const title = option.dataset.title;
      const extraOptionAttributes = option.dataset;

      data = {
        value: value,
        title: title,
        name: customSelect.dataset.name,
        gid: customSelect.dataset.gid,
        hasChanged: input.value === value ? false : true,
        parent: customSelect,
        extraAttributes,
        extraOptionAttributes
      };

      if (data.hasChanged) {
        customSelectReset(customSelect);
        option.dataset.selected = 'true';
        input.value = value;
        displayTitle.innerHTML = title;
      }
    }
  });

  return data;
}

export const customSelectReset = (elm) => {
  const input = elm.querySelector('input') as HTMLInputElement;
  const displayTitle = elm.querySelector('.custom-select__value') as HTMLElement;
  const value = input.dataset.default;

  input.value = value;
  displayTitle.innerHTML = value;
  const options = elm.querySelectorAll('.custom-select__panel li') as NodeListOf<HTMLElement>;

  options.forEach((option) => {
    option.dataset.selected = 'false';
  });
};

export const customSelectResetAll = (context: HTMLElement | Document = document) => {
  const instances = context.querySelectorAll('.custom-select:not([data-reset="false"])') as NodeListOf<HTMLElement>;

  instances.forEach((customSelect) => {
    const input = customSelect.querySelector('input');
    const displayTitle = customSelect.querySelector('.custom-select__value') as HTMLElement;
    const value = input.dataset.default;

    input.value = value;
    displayTitle.innerHTML = value;

    const options = customSelect.querySelectorAll('.custom-select__panel li') as NodeListOf<HTMLElement>;

    options.forEach((option) => {
      option.dataset.selected = 'false';
    });
  });
};
